import React from 'react';
import { ShoppingBagIcon } from 'lucide-react';
import { useCart, Product } from '../context/CartContext';
import { Link } from 'react-router-dom';
interface ProductCardProps {
  product: Product;
}
const ProductCard: React.FC<ProductCardProps> = ({
  product
}) => {
  const {
    addToCart
  } = useCart();
  const handleAddToCart = (e: React.MouseEvent) => {
    e.preventDefault(); // Prevent navigation when clicking the button
    e.stopPropagation(); // Stop event from bubbling up
    addToCart(product);
  };
  return <Link to={`/product/${product.id}`} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 block" data-id="element-431">
      <div className="h-48 overflow-hidden" data-id="element-432">
        <img src={product.image} alt={product.name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-300" onError={e => {
        e.currentTarget.src = 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?q=80&w=600&auto=format&fit=crop';
      }} data-id="element-433" />
      </div>
      <div className="p-4" data-id="element-434">
        <h3 className="text-lg font-semibold text-gray-800" data-id="element-435">{product.name}</h3>
        <p className="text-[#4caf50] font-medium mt-1" data-id="element-436">{product.price}</p>
        <p className="text-gray-600 text-sm mt-2 line-clamp-2" data-id="element-437">
          {product.description}
        </p>
        <button onClick={handleAddToCart} className="mt-4 w-full bg-[#4caf50] text-white py-2 rounded flex items-center justify-center gap-2 hover:bg-[#3d8b40] transition-colors" data-id="element-438">
          <ShoppingBagIcon className="h-4 w-4" data-id="element-439" />
          Add to Cart
        </button>
      </div>
    </Link>;
};
export default ProductCard;